import type { FC, ReactNode } from 'react';
import type { ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { isEmptyOrNull } from '@/shared/utils/string';

// TODO: maybe unify with other empty views

const styles = StyleSheet.create({
  content: {
    flex: 1,
    flexGrow: 1,
    flexDirection: 'column',
    gap: 20,
    paddingVertical: 40,
    paddingHorizontal: 30,
    alignItems: 'center'
  },
  text: { textAlign: 'center' }
});

type Props = {
  header?: ReactNode;
  title?: string;
  icon?: ReactNode;
  subtitle?: string;
  footer?: ReactNode;
  style?: ViewStyle;
};

export const FallbackContent: FC<Props> = ({
  header,
  title,
  icon,
  subtitle,
  footer,
  style
}) => (
  <View style={[style, styles.content]}>
    {header}
    {!isEmptyOrNull(title) && (
      <Text variant="headlineMedium" style={styles.text}>
        {title}
      </Text>
    )}
    {icon}
    {!isEmptyOrNull(subtitle) && (
      <Text variant="titleMedium" style={styles.text}>
        {subtitle}
      </Text>
    )}
    {footer}
  </View>
);
